var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("I am available for")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-info",
            attrs: { "active-class": "" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-left" }),
            _vm._v(" Back\n      "),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm.talentBudgetsHaveBeenPreLoaded
              ? _c(
                  "div",
                  { staticClass: "col-md-10 col-lg-8" },
                  [
                    _c("div", { staticClass: "panel panel-grey" }, [
                      _c(
                        "div",
                        { staticClass: "panel-body" },
                        [
                          _vm.$budgetRangeTags
                            ? [
                                _c("h3", [_vm._v("Budget Range")]),
                                _vm._v(" "),
                                _vm.budgetRangeTags
                                  ? _c("tags", {
                                      attrs: {
                                        type: "budgetRange",
                                        allowCreate: false,
                                        multiple: false,
                                      },
                                      model: {
                                        value: _vm.budgetRangeTags,
                                        callback: function ($$v) {
                                          _vm.budgetRangeTags = $$v
                                        },
                                        expression: "budgetRangeTags",
                                      },
                                    })
                                  : _c("pickstar-loading"),
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ladda-button",
                            {
                              staticClass:
                                "btn btn-primary pull-right margin-t-2",
                              attrs: {
                                type: "submit",
                                click: _vm.handleSaveTagsCallback,
                              },
                            },
                            [
                              _vm._v(
                                "\n                Save Changes\n              "
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel panel-grey" }, [
                      _c("div", { staticClass: "panel-body" }, [
                        _c("h4", [_vm._v("In Person")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "large-checklist" },
                          _vm._l(
                            _vm.inPersonOpportunities,
                            function (opportunity) {
                              return _vm.talentBudgetsHaveBeenPreLoaded
                                ? _c(
                                    "profile-talent-availability-opportunity-item",
                                    {
                                      key: opportunity.id,
                                      attrs: {
                                        budget: _vm.budget,
                                        opportunity: opportunity,
                                        opportunities:
                                          _vm.inPersonOpportunities,
                                        budgets: _vm.talentOpportunityBudget,
                                      },
                                    }
                                  )
                                : _vm._e()
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _c("h4", { staticClass: "m-t-md" }, [_vm._v("Online")]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "large-checklist" },
                          _vm._l(
                            _vm.onlineOpportunities,
                            function (opportunity) {
                              return _vm.talentBudgetsHaveBeenPreLoaded
                                ? _c(
                                    "profile-talent-availability-opportunity-item",
                                    {
                                      key: opportunity.id,
                                      attrs: {
                                        budget: _vm.budget,
                                        opportunity: opportunity,
                                        opportunities: _vm.onlineOpportunities,
                                        budgets: _vm.talentOpportunityBudget,
                                      },
                                    }
                                  )
                                : _vm._e()
                            }
                          ),
                          1
                        ),
                        _vm._v(" "),
                        _vm.userCanSetEsportsOpportunities
                          ? _c("h4", { staticClass: "m-t-md" }, [
                              _vm._v("Gaming"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.userCanSetEsportsOpportunities
                          ? _c(
                              "ul",
                              { staticClass: "large-checklist" },
                              _vm._l(
                                _vm.esportsOpportunities,
                                function (opportunity) {
                                  return _vm.talentBudgetsHaveBeenPreLoaded
                                    ? _c(
                                        "profile-talent-availability-opportunity-item",
                                        {
                                          key: opportunity.id,
                                          attrs: {
                                            budget: _vm.budget,
                                            opportunity: opportunity,
                                            opportunities:
                                              _vm.esportsOpportunities,
                                            budgets:
                                              _vm.talentOpportunityBudget,
                                          },
                                        }
                                      )
                                    : _vm._e()
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "margin-20" }),
                    _vm._v(" "),
                    _c(
                      "ladda-button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "submit",
                          click: _vm.handleSaveOpportunitiesCallback,
                        },
                      },
                      [_vm._v("\n            Save Changes\n          ")]
                    ),
                  ],
                  1
                )
              : _c("pickstar-loading"),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }